exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".checkbox {\n\tdisplay: inline-block;\n\tmargin: auto 10px;\n}\n\n.checklabel {\n\tpadding-left: 5px;\n}\n\n.col-xs-6 {\n\tmargin: 10px auto;\n}\n\nh4 {\n\tmargin-top: 0;\n}\n\n.ui-datatable table {\n\ttable-layout: auto !important;\n}\n\n.ui-datatable-tablewrapper {\n\toverflow-x: scroll;\n}\n\n.ui-datatable.ui-datatable-resizable .ui-datatable-thead > tr > th,\n.ui-datatable.ui-datatable-resizable .ui-datatable-tfoot > tr > td,\n.ui-datatable.ui-datatable-resizable .ui-datatable-data > tr > td {\n\toverflow: initial !important;\n}\n\n.overlay {\n\tfloat: left;\n\tposition: absolute;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 100%;\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-align: center;\n\t    -ms-flex-align: center;\n\t        align-items: center;\n\t-webkit-box-pack: center;\n\t    -ms-flex-pack: center;\n\t        justify-content: center;\n\tbackground-color: rgba(0, 0, 0, 0.75);\n}\n\n.loading {\n\theight: 40px;\n\twidth: 40px;\n\tmargin: 0 auto;\n\tborder-radius: 50%;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/baselkilani/work/ODOT/projects/dmscontrol/DmsControl/src/app/dmslog/dmslog.component.css
// module id = ../../../../../src/app/dmslog/dmslog.component.css
// module chunks = main